import { useDispatch, useSelector } from 'react-redux';
import { ResearchResults_ResponseData } from '../api/chatApi/chatApi';
import { RootState } from '../store';
import { useEffect } from 'react';
import { SagaActionType } from '../store/sagas/sagaActions';

const useResearchHistory = () => {
  const dispatch = useDispatch();

  const researchResults: Array<ResearchResults_ResponseData> | undefined = useSelector((state: RootState) => {
    return state.research.researchResults;
  });

  useEffect(() => {
    if (researchResults === undefined) {
      dispatch({ type: SagaActionType.START_LOAD_RESEARCH_HISTORY });
    }
  }, [dispatch, researchResults]);

  return researchResults || [];
};

export default useResearchHistory;
